import _ from "lodash";

function sortRagReportTableItems(value, sortKey, listPositions) {
  // TODO: This takes the table items and sorts them, so needs to filter out
  // table headings when its not the default ordering
  // We should change this so it sorts the issues before we generate
  // the table items
  const sortedItems = value.filter(row => row.children.length > 1);
  let result;
  if (sortKey === "Needs Review") {
    const order = {
      1: 5,
      2: 10,
      3: 0,
    };
    result = _.sortBy(sortedItems, item => order[item.review_state]);
  } else if (sortKey === "State") {
    result = _.sortBy(sortedItems, item => {
      const state = item.issue_status;
      if (state === "red") {
        return 0;
      }
      if (state === "amber") {
        return 5;
      }
      if (state === "grey") {
        return 10;
      }
      return 15;
    });
  } else if (sortKey === "Custom") {
    const items = value.filter(item => item.issue || item.additional_item);

    if (listPositions?.length) {
      const positionedItems = items
        .filter(item =>
          listPositions.find(
            pos => pos.id === (item.document_issue_id || item.additional_item),
          ),
        )
        .map(item => ({
          ...item,
          list_position: listPositions.find(
            pos => pos.id === (item.document_issue_id || item.additional_item),
          ).list_position,
        }))
        .sort((a, b) => a.list_position - b.list_position);

      const nonPositionedItems = items.filter(
        item =>
          !listPositions.find(
            pos => pos.id === (item.document_issue_id || item.additional_item),
          ),
      );

      result = [...nonPositionedItems];

      positionedItems.forEach(item => {
        const pos = Math.min(item.list_position, result.length);
        result.splice(pos, 0, item);
      });
    } else {
      const positionedItems = items
        .filter(item => item.list_position !== undefined)
        .sort((a, b) => a.list_position - b.list_position);

      const nonPositionedItems = items.filter(
        item => item.list_position === undefined,
      );

      result = [...nonPositionedItems];

      positionedItems.forEach(item => {
        const pos = Math.min(item.list_position, result.length);
        result.splice(pos, 0, item);
      });
    }
  } else {
    result = value;
  }

  return result;
}

export default sortRagReportTableItems;
